// Transition: change price from ecwid
// html price !
// selected target currency =
// Data attribute: target currency =
// Data attribute: original price !
// Data attribute: converted price !
// Конвертируем заново, обновляем аттрибуты original и converted
import { translatePrice } from '../conversion';
import { setElementState } from '../priceControls';

const matchState = (state) => {
  return (
    state.selectedTargetCurrency === state.convertedCurrency &&
    state.htmlPrice !== state.originalPrice &&
    state.htmlPrice !== state.convertedPrice
  );
};

const handle = (priceElement, state, config) => {
  const price = translatePrice(state.htmlPrice, config);

  const newState = {
    ...state,
    originalPrice: state.htmlPrice,
    convertedPrice: price,
  };

  setElementState(priceElement, newState);
};

export default { matchState, handle, name: 'priceChange' };
